$(document).ready(function () {
  $(document).on("click", "#category_filters_btn", function (e) {
    e.preventDefault();
    $("body").addClass("no_scroll");
    $("#filters").addClass("_active");
    $(".filters_overlay").addClass("_active");
  });

  $(document).on("click", "#main_filters [data-filter]", function (e) {
    e.preventDefault();
    let filter_id = $(this).data("filter");
    $('.filters_values[data-filter="' + filter_id + '"]').addClass("_active");
  });

  $(document).on("click", ".filters_title._close", function (e) {
    e.preventDefault();
    $(this).closest(".filters_values").removeClass("_active");
  });

  $(document).on(
    "click",
    ".filters_overlay, .filters_close, .filters_close svg",
    function (e) {
      e.preventDefault();
      $("body").removeClass("no_scroll");
      $("#filters").removeClass("_active");
      $(".filters_overlay").removeClass("_active");
      $( '.snize-filters-sidebar.snize-product-filters' ).removeClass("_active");
      $(".filters_values._active").removeClass("_active");
    }
  );

  $(document).on("click", ".filter_price_btn._plus", function (e) {
    e.preventDefault();

    let input = $(this).closest(".filter_price_input").find("input"),
      value = $(input).val();

    if (value < 1) {
      $(input).val(1);
    } else if (parseInt(value) + 1 == 1) {
      $(input).val(parseInt(value) + 1);
      $(this)
        .closest(".filter_price_input")
        .find(".filter_price_btn._minus")
        .addClass("_disable");
    } else {
      $(input).val(parseInt(value) + 1);
      $(this)
        .closest(".filter_price_input")
        .find(".filter_price_btn._minus")
        .removeClass("_disable");
    }
  });

  $(document).on("click", ".filter_price_btn._minus", function (e) {
    e.preventDefault();

    let input = $(this).closest(".filter_price_input").find("input"),
      value = $(input).val();

    if (value > 1) {
      $(input).val(parseInt(value) - 1);
    }
    if (parseInt(value) - 1 == 1) {
      $(this).addClass("_disable");
    }
  });
});
